<template>
    <div class="avatar-root" :class="size">
        <b-img
            v-if="image"
            class="w-100 h-100 image"
            :src="image + (noSuffix ? '' : '/small.jpg')"
            rounded="circle"
        />

        <div v-else class="avatar-base noselect" :class="size">
            <slot />
        </div>

        <div v-if="hasFooterSlot" class="badge">
            <slot name="badge" />
        </div>

        <transition name="fade">
            <div v-if="outline" class="outline">
                <div class="l1" />
                <div class="l2" />
            </div>
        </transition>
    </div>
</template>

<script>
export default {
    name: 'Avatar',
    props: {
        image: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'md',
        },
        outline: {
            type: Boolean,
            default: false,
        },
        noSuffix: Boolean,
    },
    computed: {
        hasFooterSlot() {
            return !!this.$slots['badge'];
        },
    },
};
</script>

<style scoped lang="scss">
.avatar-root {
    position: relative;
    border-radius: 50%;
}
.avatar-base {
    overflow: hidden;

    display: flex;
    align-items: center;
    justify-content: center;

    border-radius: 50%;
    font-size: 1.25rem;

    background-color: #bdbdbd;
    color: white;

    width: 100%;
    height: 100%;

    &.md,
    &.normal {
        font-size: 1.25rem;
    }

    &.lg,
    &.large {
        font-size: 1.5rem;
    }

    &.xl {
        font-size: 3.6rem;
    }

    &.xxl,
    &.huge {
        font-size: 4.6rem;
    }
}

.md,
.normal {
    width: 40px;
    height: 40px;
}
.lg,
.large {
    width: 60px !important;
    height: 60px !important;
}
.xl {
    width: 100px !important;
    height: 100px !important;
}
.xxl,
.huge {
    font-size: 2.8rem;
    width: 140px !important;
    height: 140px !important;
}

.badge {
    position: absolute;
    bottom: 0;
    right: 0;
    height: 16px;
    width: 16px;
    border-radius: 50%;
    background-color: var(--primary);
    display: flex;
    align-items: center;
    justify-content: center;
}
.image {
    object-fit: cover;
}

.outline {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 5px solid var(--primary);

    .l1 {
        position: absolute;
        top: -10%;
        left: -10%;
        width: 120%;
        height: 120%;
        border-radius: 50%;
        border: 2px solid #89c4ff;
    }

    .l2 {
        position: absolute;
        top: -15%;
        left: -15%;
        width: 130%;
        height: 130%;
        border-radius: 50%;
        border: 1px solid #d9ecff;
    }
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
